type Cell = string | number | null | undefined

const saveBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

// BOM so Excel reads UTF-8.
export const downloadCsv = (filename: string, header: string[], rows: Cell[][]) => {
  const cell = (v: Cell) => {
    const s = v == null ? '' : String(v)
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
  }
  const text = '﻿' + [header, ...rows].map((r) => r.map(cell).join(',')).join('\r\n')
  saveBlob(new Blob([text], { type: 'text/csv;charset=utf-8' }), filename.endsWith('.csv') ? filename : `${filename}.csv`)
}

export const downloadXlsx = async (filename: string, header: string[], rows: Cell[][], sheet = 'Report') => {
  const XLSX = await import('xlsx')
  const worksheet = XLSX.utils.aoa_to_sheet([header, ...rows.map((r) => r.map((v) => (v == null ? '' : v)))])
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, sheet.replace(/[[\]:*?/\\]/g, ' ').slice(0, 31))
  XLSX.writeFile(workbook, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`)
}
